'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OffensiveLanguage = require('./OffensiveLanguage');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OffensiveLanguage).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/OffensiveLanguage/index.js
// module id = 1244
// module chunks = 1